
export const COMPANY_INFO = {
  name: "Jensen & Sørensen ApS",
  tagline: "Din tømrer i Aalborg – Kvalitet og ekspertise i topklasse",
  address: "Egeparken 3 1. 3., 9000 Aalborg",
  email: "jsbyg.info@gmail.com",
  phone: {
    simon: "28 39 86 10",
    mark: "24 34 39 20"
  },
  cvr: "43572326",
  facebook: "https://www.facebook.com/jensensorensenaps"
};

export const SERVICES = [
  {
    id: "nyt-tag",
    title: "Nyt tag",
    slug: "nyt-tag",
    description: "Vi lægger nyt tag med fokus på både æstetik og holdbarhed. Uanset om det er tegl, eternit eller tagpap, sikrer vi en tæt og smuk løsning.",
    image: "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/9cd05a39-281e-4399-bd2f-dc7b85c472f6.webp", // image00028.jpeg fra WeTransfer
    video: "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/f14d50ed-e6c7-4111-8e21-4bd15cc74584.mp4"
  },
  {
    id: "traeterrasse",
    title: "Træterrasse",
    slug: "traeterrasse",
    description: "Drømmer du om en smuk træterrasse? Vi bygger skræddersyede terrasser i de bedste materialer, der holder til det danske vejr.",
    image: "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/367bbb1f-d6a0-4237-9154-9c202da5aecb.jpg",
    content: [
      {
        heading: "FORLÆNG SOMMEREN MED EN TRÆTERRASSE",
        text: [
          "En træterrasse er et populært valg for mange boligejere. Vi tilbyder opbygning af træterrasser i Aalborg, Nørresundby, Brønderslev og Støvring. Vi kan hjælpe med design og opbygning af træterrasser, så vi kan skræddersy en terrasse, der passer perfekt til din bolig og behov.",
          "Vi kan hjælpe dig med træterrasser med højbede, rækværk, trapper og plantekasser. Vi lytter til dine ønsker og vi er altid klar på en udfordring. Har du idéerne, kan vi skabe dem. Lad os høre om dine ønsker, så finder vi i fællesskab den helt rigtige træterrasse til jer.",
          "Kontakt os i dag og få et uforpligtende tilbud"
        ]
      },
      {
        heading: "DIN LOKALE TØMRER TIL TRÆTERRASSE",
        text: [
          "Når du vælger Jensen & Sørensen ApS til træterrasser, kan du være sikker på at kvaliteten er i top. Vi arbejder effektivt og omhyggeligt med vores håndværk. Vi går op i selv den mindste detalje og vi kan tilpasse terrassen til både underlaget og niveauet på huset.",
          "Vi kan hjælpe dig med at skræddersy en terrasse. Har du niveauforskel, kan vi lave en træterrasse med rækværk og trappe, så du får let forbindelse mellem køkken og terrasse. En træterrasse i niveau skaber et udendørs rum, som kan få huset til at føles større. Vi kan lave træterrasse i flere niveauer, så du får forskellige hyggekroge.",
          "En træterrasse er en god og holdbar løsning, som passer godt til langt de fleste boliger. Vi går meget op i at skabe træterrasser, der harmonerer med både hus og funktionalitet."
        ]
      },
      {
        heading: "FÅ EN PRIS PÅ TRÆTERRASSE I DAG",
        text: [
          "Vi ser frem til at høre fra dig med dine ønsker til en træterrasse. Vi står klar til at skabe træterrasser som indbyder til hygge og samvær. Vi arbejder omhyggeligt med vores håndværk og vi bruger udelukkende kvalitetstræ til at bygge træterrasser. Prisen på en træterrasse afhænger naturligvis af hvilken type træ du vælger, samt størrelsen på terrassen og hvor avanceret opbygningen skal være.",
          "Vi kommer gerne med et uforpligtende tilbud på en træterrasse, som passer netop til dine ønsker og behov. Kontakt os i dag på telefonnummer 28 39 86 10 eller 24 34 39 20, eller send os en mail på jsbyg.info@gmail.com. Du kan også til enhver tid udfylde vores kontaktformular."
        ]
      }
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/14075d69-a72c-4e4b-a164-decd61884807.webp",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/2707c359-c236-4bd0-b6ef-fdb2cebb3b97.jpeg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/7b273530-f28d-4f89-9ef6-2513a08626e3.jpg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/d234a256-a6e8-4138-80c9-9f618b15dfdc.jpg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/b922a73b-7c87-45a9-822e-b5a41f52fea2.jpeg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/6e94a96b-6b74-4dcf-b849-53caf38d4908.jpeg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/77a14002-bf58-4824-b99a-07ec11f51e17.jpeg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/f1dc3f24-3fc5-4e30-9f47-f6446f3f6699.jpeg"
    ]
  },
  {
    id: "carporte",
    title: "Carporte",
    slug: "carporte",
    description: "Beskyt din bil med en stilfuld carport. Vi designer og opfører carporte, der passer perfekt til din boligs arkitektur.",
    image: "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/e86d3d0e-aba1-4f35-b2b3-c5277e256381.webp",
    content: [
      {
        heading: "CARPORTE HOS JENSEN & SØRENSEN APS",
        text: [
          "Hos Jensen & Sørensen ApS tilbyder vi professionel opbygning af carporte for både private og erhvervskunder i Aalborg, Nørresundby, Brønderslev og Støvring området. Vi har erfaring med at designe og bygge forskellige typer af carporte.",
          "Vi kan hjælpe dig med at designe hvordan din carport skal se ud og hvor stor den skal være. Vi kan skabe skræddersyede carporte, der passer perfekt til dit hus og dine hverdagsbehov.",
          "Kontakt os i dag og få et uforpligtende tilbud"
        ]
      },
      {
        heading: "CARPORT I TRÆ - EN HOLDBAR LØSNING",
        text: [
          "En carport i træ er et meget populært valg, da træ er et utroligt holdbart materiale og som giver mulighed for at bygge en carport forholdsvis effektivt og hurtigt. Træ giver et varmt og indbydende udtryk, der passer godt til langt de fleste boliger. Vi bruger udelukkende kvalitetstræ og går meget op i vores håndværk. Vi kan bygge carporte, der er solide og holdbare. Vores carporte kan holde i mange år og kræver stort set ingen vedligeholdelse. Vi arbejder tæt sammen med dig for at designe en carport, der opfylder dine behov og som passer perfekt til din bolig.",
          "En carport med skur giver dig mange muligheder. En carport med skur giver dig muligheden for både at få bilen i tørvejr, samtidig med at du får mere opbevaringsplads til haveredskaber, cykler og legetøj."
        ]
      },
      {
        heading: "DOBBELT CARPORT I TRÆ - PLADS OG FUNKTIONALITET",
        text: [
          "Hvis du har brug for ekstra plads, kan en dobbelt carport i træ være den perfekte løsning. En dobbelt carport giver dig mulighed for at parkere to biler, eller du kan bruge den ekstra plads til opbevaring af cykler, plæneklipper og legetøj. Hos Jensen & Sørensen ApS kan vi designe og bygge en dobbelt carport, der både er funktionel og pæn.",
          "Vi sikrer, at carporten er solidt bygget og kan modstå slid. Vi går meget op i funktionalitet når vi bygger carporte, vi skaber carporte, som gør din hverdag lettere og som opfylder alle dine behov."
        ]
      },
      {
        heading: "FÅ EN PRIS PÅ EN CARPORT",
        text: [
          "Kontakt os i dag for at høre mere om prisen på en carport. Prisen på en carport varierer afhængigt af hvordan den skal se ud og hvor stor den skal være. Vi ser frem til at høre om dine ønsker til en carport. Vi er naturligvis altid klar med et uforpligtende tilbud.",
          "Kontakt os i dag på telefonnummer 28398610 eller 24 34 39 20. Du er også velkommen til at sende os en mail på jsbyg.info@gmail.com eller udfylde vores kontaktformular og vi vender tilbage hurtigst muligt."
        ]
      }
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/28b84288-e40a-40b9-b9ee-fb0446d0509c.webp",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/e762374a-1330-4504-9739-c8c3114c6085.jpg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/b265d71e-8b34-4482-bb74-1ac468275a30.jpg"
    ]
  },
  {
    id: "vinduer",
    title: "Vinduer",
    slug: "vinduer",
    description: "Vi udskifter dine gamle vinduer med nye, energirigtige løsninger, der forbedrer både indeklima og varmeregning.",
    image: "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/4364d1c4-a00f-47b3-ac3a-b25c19a14f90.jpeg",
    content: [
      {
        heading: "UDSKIFTNING AF VINDUER I AALBORG OG OMEGN",
        text: [
          "Hos Jensen & Sørensen ApS tilbyder vi professionel udskiftning af vinduer i Aalborg, Støvring, Brønderslev og Nørresundby. Vi er klar til at hjælpe dig med at forbedre både sikkerheden og isolering i dit hjem med udskiftning af gamle vinduer.",
          "Uanset om det drejer som om almindelige vinduer, ovenlysvinduer eller montering af kviste, kan vi sikre dig en løsning af høj kvalitet.",
          "Kontakt os i dag og få et uforpligtende tilbud"
        ]
      },
      {
        heading: "FORDELE VED UDSKIFTNING AF VINDUER",
        text: [
          "Der er mange fordele ved at skifte dine vinduer med nye. En af fordelene er højere sikkerhed. Moderne vinduer er ofte udstyret med bedre og mere avancerede låseteknikker og stærkere glas, hvilket gør det markant sværere for indbrudstyven at bryde ind i din bolig.",
          "Nye vinduer har kraftigere og tykkere glas end gamle vinduer, hvilket gør at mindre varme kan slippe ud. Nye vinduer vil derfor også ofte kunne mærkes positivt på varmeregningen. Med nye vinduer vil du derfor også få bedre komfort og mere stabil temperatur."
        ]
      },
      {
        heading: "PROFESSIONEL MONTERING AF NYE VINDUER",
        text: [
          "Når du vælger os til at montere dine nye vinduer, kan du være sikker på at vi arbejder professionelt og omhyggeligt. Vi sikrer at dine vinduer bliver monteret korrekt og at de passer til stilen på ejendommen. Vi samarbejder med nogle af landets førende leverandører af vinduer, hvilket betyder, at vi kan tilbyde vinduer af høj kvalitet, uanset om du skal bruge standardvinduer eller specialmål.",
          "Vi har erfaring med montering og udskiftning af vinduer i både erhvervsbygninger, sommerhuse og boliger. Udover at skifte almindelige vinduer, kan vi også lave ovenlysvinduer og kviste."
        ]
      },
      {
        heading: "KONTAKT OS FOR EN PRIS PÅ NYE VINDUER",
        text: [
          "Overvejer du at få nye vinduer? Kontakt Jensen & Sørensen ApS i dag for at få en pris på nye vinduer. Vi tilbyder konkurrencedygtige priser. Vi er klar til at hjælpe dig med at fra opmåling, bestilling og montering.",
          "Ring til os på telefonnummer 28398610 eller 24 34 39 20. Du er også velkommen til at sende os en mail på jsbyg.info@gmail.com eller udfylde vores kontaktformular."
        ]
      }
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/635cf316-3809-4415-bd37-601ff34c8b85.webp",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/e65cd382-58ac-4594-b011-de4345cdeef6.jpeg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/ab31d6f6-a6e4-4b79-b9ce-8a2350730fc3.jpeg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/49790b1d-d85a-4a09-a139-25d544c90c0e.jpeg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/2806b839-9e80-4403-984b-dfa33b7621e7.jpeg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/bd26b865-848e-450f-8b5f-9755c63dd815.jpeg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/1000955d-9526-4f2c-9ff4-c98079374dc0.jpg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/5f60b069-d0be-4e72-b823-022658f23d4a.jpg"
    ]
  },
  {
    id: "gulve",
    title: "Gulve",
    slug: "gulve",
    description: "Vi lægger alle typer trægulve og sikrer en finish, der løfter hele rummet. Kvalitet og detaljer er i højsædet.",
    image: "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/2981d177-e54c-4750-957c-cb1f0318d4d3.jpeg",
    content: [
      {
        heading: "NYE GULVE - KVALITET OG HÅNDVÆRK I TOPKLASSE",
        text: [
          "Hos Jensen & Sørensen ApS tilbyder vi også lægning af nye gulve for både private og erhvervskunder i Aalborg, Nørresundby, Brønderslev og Støvring området. Vi har erfaring i at arbejde med forskellige gulvtyper og materialer.",
          "Vi kan hjælpe dig med at skræddersy dit nye gulv, som passer både til jeres behov og stilen på boligen. Vi kan hjælpe med gulvlægning i forbindelse med både nybyggeri og renoveringsprojekter. For os er ingen opgave for stor eller for lille.",
          "Kontakt os i dag og få et uforpligtende tilbud"
        ]
      },
      {
        heading: "FORSKELLIGE TYPER AF NYE GULVE",
        text: [
          "Vi kan lægge alle typer gulve og vi kan tilpasse gulvet til din smag og stil. Trægulve er et populært valg for mange boligejere, da de giver et varmt og naturligt udseende. Trægulve er også kendt for deres holdbarhed og tidløse udtryk. Trægulve er altid et sikkert valg og du får et gulv der er slidstærkt og pænt i mange år.",
          "Hvis du ønsker noget mere specielt, så kan vi også lægge et sildebensgulv. Sildebensgulve er blevet meget populært i mange forskellige typer boliger. Sildebensgulve kan i dag fås i mange kvaliteter og materialer, så du kan helt sikkert finde et, som passer til din stil og dit budget."
        ]
      },
      {
        heading: "HVAD KOSTER NYE GULVE?",
        text: [
          "Prisen på nye gulve kan variere afhængigt af materialevalg, gulvareal og om hvor omfattende opgaven er. Hos Jensen & Sørensen ApS tilbyder vi gennemsigtighed og konkurrencedygtige priser.",
          "Vi tager os tid til at forstå dine ønsker og forventninger, så vi kan skræddersy et tilbud til jer. Uanset om du ønsker trægulv, parketgulv eller sildebensgulv, kan vi sikre, at du får høj kvalitet til en fair pris."
        ]
      },
      {
        heading: "NYE GULVE I AALBORG, NØRRESUNDBY, BRØNDERSLEV OG STØVRING",
        text: [
          "Vi ved, at hver bolig er unik og derfor tilbyder vi også at skræddersy en løsning, der passer perfekt til netop jeres bolig. Vi arbejder altid med kvalitetsmaterialer og sørger for at dit nye gulv bliver lagt professionelt og korrekt, så du får et flot, slidstærkt og holdbart resultat.",
          "Kontakt os på telefonnummer 28398610 eller 24 34 39 20. Du kan også sende os en mail på jsbyg.info@gmail.com eller udfylde vores kontaktformular, så vender vi tilbage hurtigst muligt."
        ]
      }
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/4cd9c4ba-a978-4318-b5be-f3fb5edf6588.webp",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/3c4f65e4-6b42-4261-993e-06f1df014936.jpeg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/9008c7e8-4f94-4768-b6c8-b9d037500dd0.jpeg"
    ]
  },
  {
    id: "renovering",
    title: "Renovering",
    slug: "renovering",
    description: "Vi hjælper med alt fra mindre udbedringer til større renoveringsprojekter. Vi giver dit hjem nyt liv med respekt for det eksisterende.",
    image: "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/b7e5b5fe-38cb-447d-b6bc-c208c48d0211.jpeg",
    content: [
      {
        heading: "RENOVERING AF HUS - MODERNISERING I TOPKLASSE",
        text: [
          "Hos Jensen & Sørensen ApS kan vi hjælpe dig med alt indenfor tømrerfaget, og vi har erfaring med renovering af huse i Aalborg, Nørresundby, Støvring og Brønderslev.",
          "Vi arbejder tæt sammen med private boligejere for at modernisere og forbedre boliger, så de opfylder nutidens krav og behov. Uanset om du drømmer om at renovere et 70’er hus, eller om du har brug for en totalrenovering af et ældre hus, står vi klar til at hjælpe dig.",
          "Kontakt os i dag og få et uforpligtende tilbud"
        ]
      },
      {
        heading: "RENOVERING AF 70’ER HUS - GIV DIT HJEM ET MODERNE PRÆG",
        text: [
          "Renovering af 70’er huse kan give dit hjem et helt nyt liv. Mange 70’er huse har stor charme, men de trænger ofte til en kærlig hånd for at leve op til moderne standarder. Vi kan hjælpe dig med alt fra ombygning af huset til indvendig renovering, så du får mere lys, bedre isolering og en mere tidssvarende planløsning.",
          "Hos Jensen & Sørensen ApS sørger vi for, at renoveringen forløber gnidningsfrit og effektivt, og vi arbejder altid i tæt dialog med dig som kunde. Vi kan stå for fagentreprisen ved større renoveringer.",
          "En indvendig renovering af huset kan gøre en kæmpe forskel for boligens udtryk og den funktionelle værdi. Uanset om du ønsker at åbne op for mere lys og luft, modernisere køkkenet, eller skabe et luksuriøst badeværelse, kan vi hjælpe dig med at realisere drømme. Vi tilbyder skræddersyede løsninger, der passer til netop dine behov, din stil og dine ønsker."
        ]
      },
      {
        heading: "TOTAL HUSRENOVERING - FRA GAMMELT TIL NYT",
        text: [
          "Står du overfor en totalrenovering af dit hus? Den kan virke som en stor og uoverskuelig opgave, men med Jensen & Sørensen bliver det en positiv og spændende proces. Vi har erfaring med alle aspekter i forbindelse med renoveringer og vi kan tage hånd om både strukturelle ændringer og de små detaljer.",
          "Med en totalrenovering får du mulighed for at skabe et hjem, der passer præcis til dine ønsker og behov. Du får et hjem der både er med moderne standarder og funktionaliteten i top."
        ]
      },
      {
        heading: "FÅ EN PRIS PÅ RENOVERING AF DIT HUS",
        text: [
          "Vi giver gerne et uforpligtende tilbud, så du får en klar idé om renovering af huset og prisen. Vi har altid fokus på kvalitetsmaterialer og kundetilfredshed, og vi går aldrig på kompromis med vores håndværk.",
          "Er du klar til at tage næste skridt i din hus renovering? Kontakt Jensen & Sørensen ApS i dag. Ring til os på telefonnummer 28398610 eller 24 34 39 20. Du kan også sende os en mail på jsbyg.info@gmail.com eller udfylde vores kontaktformular."
        ]
      }
    ],
    gallery: [
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/071f9c68-d49a-45ed-8888-5aa79a556ff6.webp",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/3ee03ed6-04a6-4e86-bcc6-8814d4c1f268.jpg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/0a1eb255-9544-4c62-b6dd-ed7040b6a33f.jpg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/eedbbc3c-db2c-41cf-ae7c-ae4b3accb573.jpg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/6e53b509-e6be-4761-9cc5-b18caeb9c8dc.jpeg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/55aa47f3-3074-4ad0-8c56-c182e5ab388a.jpeg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/2e883428-59d7-4c7c-9583-e1c05f52fba7.jpeg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/9cbfa3e6-8345-428d-a140-67dedec01de0.jpeg"
    ]
  }
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Mads Poulsen",
    text: "Jensen & Sørensen leverede et fantastisk stykke arbejde med vores nye tag. Professionelle, hurtige og ryddede pænt op efter sig. Kan varmt anbefales!",
    project: "Nyt tag i Aalborg"
  },
  {
    id: 2,
    name: "Lene Jensen",
    text: "Vi fik bygget en stor træterrasse, og resultatet er over al forventning. Simon og teamet var super gode til at rådgive os undervejs.",
    project: "Træterrasse i Støvring"
  },
  {
    id: 3,
    name: "Anders Holm",
    text: "Pålidelige håndværkere er guld værd. Mark og Simon holdt alle aftaler og prisen var fair. Vi bruger dem helt sikkert igen.",
    project: "Renovering i Nørresundby"
  }
];

export const PROJECTS = [
  {
    id: 1,
    title: "Droneinspektion af Tag",
    location: "Aalborg SV",
    image: "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/421eaa30-2081-49f6-8651-5e35360ad07b.jpeg",
    images: [
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/421eaa30-2081-49f6-8651-5e35360ad07b.jpeg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/04b7e499-0904-4d73-b174-ef9ab24219ac.jpeg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/d4e7d13f-a5cf-405f-aaa7-5d18856c4335.jpeg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/31918e1c-6883-4cc9-8832-4dab6ad967bd.jpeg"
    ]
  },
  {
    id: 2,
    title: "Eksklusiv Træterrasse",
    location: "Støvring",
    image: "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/aa97a55f-7093-41f1-b809-00e785d01413.jpeg",
    images: [
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/aa97a55f-7093-41f1-b809-00e785d01413.jpeg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/613f8978-7989-4852-98ae-6e46822f3c91.jpg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/ddc8d0e0-8e8c-466e-a93b-eebb61aff82c.jpg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/927e3603-fc0f-441d-bf45-9e6d0b05685d.jpg"
    ]
  },
  {
    id: 3,
    title: "Dobbelt Carport",
    location: "Hasseris",
    image: "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/e86d3d0e-aba1-4f35-b2b3-c5277e256381.webp",
    images: [
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/e86d3d0e-aba1-4f35-b2b3-c5277e256381.webp",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/b03569a9-4699-4fa0-950f-4ccca6a02b87.jpg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/d2581e68-c15c-4234-8b7b-516524ba6adf.jpg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/703e2afa-1b49-4623-a454-6d431b98e8f9.jpg"
    ]
  },
  {
    id: 4,
    title: "Vinduesudskiftning",
    location: "Brønderslev",
    image: "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/4364d1c4-a00f-47b3-ac3a-b25c19a14f90.jpeg",
    images: [
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/4364d1c4-a00f-47b3-ac3a-b25c19a14f90.jpeg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/8f77bbc1-2770-469d-bac1-555a7b9b6a0b.jpg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/7d49a5fe-f260-4b13-86bb-8dd7d2b82f0c.jpg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/33112681-1082-4364-aee2-82ceafb447f3.jpg"
    ]
  },
  {
    id: 5,
    title: "Gulvlægning",
    location: "Aalborg Øst",
    image: "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/2981d177-e54c-4750-957c-cb1f0318d4d3.jpeg",
    images: [
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/2981d177-e54c-4750-957c-cb1f0318d4d3.jpeg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/c9e9c6cc-a00a-4f1f-8acb-58765a51b1f7.jpg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/44799a50-8161-4aaa-9bf1-c49d33443202.jpg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/30a1e19c-4086-4042-ac73-83f9e1beb276.jpg"
    ]
  },
  {
    id: 6,
    title: "Totalrenovering",
    location: "Nørresundby",
    image: "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/b7e5b5fe-38cb-447d-b6bc-c208c48d0211.jpeg",
    images: [
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/b7e5b5fe-38cb-447d-b6bc-c208c48d0211.jpeg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/cccb7fcc-e4ac-40e2-8e26-d2fa4f10e94d.jpg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/356976a6-f1b4-4c20-ba9c-59c7c1ee1e35.jpg",
      "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/ba788719-f71e-4fa7-a7fb-cb0d06a764d9.jpg"
    ]
  }
];

export const ASSETS = {
  hero: "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/2d1c13e7-e398-4524-ad47-dffc5bddf374.jpg",
  simon: "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/84b9f2da-e5a2-4b4e-bd32-997547225985.jpg", // Simon fra WeTransfer
  team: "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/4b3f1ee2-bf3f-4a52-bd02-eba8ee0f0c97.jpeg", // Team fra WeTransfer
  logo: "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/88147c89-f4b4-4a7f-8f8f-c302f62ad64a.webp",
  nytTagGallery: [
    "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/1ef96222-cfec-4011-bcd0-244c9d08b00a.webp",
    "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/0fbf645c-373f-47f3-a7c6-30c304b62942.jpeg",
    "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/0d4439ff-3f68-4b5a-9b1d-4cd5b878f3b8.jpeg",
    "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/b13acdca-f24e-4fd5-b069-fde11319b953.jpeg",
    "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/6bacecf5-de40-445d-b627-77effb0c9d7d.jpeg",
    "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/7c53b2ad-eba1-4a29-9c83-c9bac691ff01.jpeg",
    "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/5f281acd-7f5a-4fc7-8a69-e5080318424c.jpeg",
    "https://assets.auxodev.dk/assets/650c050a-1b3b-43e1-83de-064d04c7258f/dcf9d017-86e3-4566-b4b4-3fd3002781c8.jpeg"
  ]
};
